<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("common.search") }}</b>
            </div>
            <div class="col-md-12 col-ld-12 col-sd-12">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchData.searchText"
                    :placeholder="$t('common.search')"
                  />
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_from") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      v-model="searchData.startDateTime"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;"
                            >{{ $t("service_history.date_to") }}:</span
                          >
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      v-model="searchData.endDateTime"
                    ></date-picker>
                  </div>
                </div>
              </div>

              <!-- Search booking available list -->
              <div class="col-sm-2 col-md-2 col-lg-2">
                <button
                  type="button"
                  class="btn btn-labeled btn-primary pull-left"
                  @click="onSearchEvent"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("common.search") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border" style="width:100%">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("eventManagement.title") }}</b>
              <lte-button
                @click="callback()"
                style="float:right;background-color:white !important;"
                type="btn btn-default"
                right_icon="fa fa-plus"
                >{{ $t("user.createnew") }}</lte-button
              >
            </div>
          </div>
          <div class="box-body">
            <b-table
              :per-page="perPage"
              :current-page="currentPage"
              striped
              hover
              :fields="gridColumns"
              :items="managementEventList"
            >
              <template #head()="data">
                {{ $t(data.label) }}
              </template>
              <template #cell()="row">
                {{ spliceString(row.item.eventName, 50) }}
              </template>
              <template #cell(startDate)="row">
                {{
                  row.item.startTime !== "00:00"
                    ? `${row.item.startTime} ${row.item.startDate}`
                    : row.item.startDate
                }}
              </template>
              <template #cell(endDate)="row">
                {{
                  row.item.endTime !== "00:00"
                    ? `${row.item.endTime} ${row.item.endDate}`
                    : row.item.endDate
                }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                  <button
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px"
                    :title="$t('common.edit')"
                    @click="onEditEvent(data.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                  <button
                    class="btn btn-success btn-sm"
                    style="margin-left: 6px"
                    :title="$t('common.sendNotification')"
                    @click="showModalConfirmSendNotification(data.item)"
                  >
                    <i class="glyphicon glyphicon-bell"></i>
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    style="margin-left: 6px"
                    :title="$t('common.delete')"
                    @click="onDeleteEvent(data.item.id)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="managementEventList.length > 0"
        >
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
      </row>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
    </div>
    <div class="modal fade" id="modal-confirm-delete-event">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4>
              {{ $t("common.delete_modal.content") }}
            </h4>
          </div>
          <div class="modal-footer">
            <button
              @click="onConfirmDeleteEvent()"
              type="button"
              class="btn btn-primary btn-sm pull-right"
            >
              {{ $t("common.delete_modal.btnYes") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!--  -->
    <div class="modal fade" id="modal-management-event-detail">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  eventData.id === 0
                    ? "eventManagement.addNew"
                    : "eventManagement.eventDetail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("banner.image") }}</label>
                  <div>
                    <img
                      id="event-img-id"
                      :src="eventData.imgUrl !== null && eventData.imgUrl !== '' ? eventData.imgUrl : noImgDefault"
                      class="news-img-class img-responsive"
                      alt="news-img">
                    <div style="padding-top: 6px; text-align: center">
                      <input
                        id="upload-event-img"
                        type="file"
                        accept="image/*"
                        @change="onSelectImg">
                      <p><small>{{ $t('common.imageRatioRequire') }}</small></p>
                      <p>{{ $t('banner.clickImageToAddOrUpdate') }}</p>
                      <span
                        v-if="eventData.imgUrl !== null && eventData.imgUrl !== ''"
                        class="remove-news-img"
                        @click="onClickRemoveImg">{{ $t('common.delete') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("eventManagement.eventName") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="eventData.eventName"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label for="">{{
                        $t("eventManagement.startDate")
                      }}</label>
                      <date-picker
                        class="form-control"
                        :config="datePickerOptions"
                        v-model="eventData.startDate"
                        placeholder="DD-MM-YYYY"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{
                        $t("eventManagement.startTime")
                      }}</label>
                      <date-picker
                        class="form-control"
                        :config="timePickerOptions"
                        v-model="eventData.startTime"
                        placeholder="HH:mm"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label for="">{{ $t("eventManagement.endDate") }}</label>
                      <date-picker
                        class="form-control"
                        :config="endDatePickerOptions"
                        v-model="eventData.endDate"
                        placeholder="DD-MM-YYYY"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="">{{ $t("eventManagement.endTime") }}</label>
                      <date-picker
                        class="form-control"
                        :config="timePickerOptions"
                        v-model="eventData.endTime"
                        placeholder="HH:mm"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("eventManagement.content") }}</label>
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="8"
                    v-model="eventData.content"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="onSave()"
              type="button"
              class="btn btn-primary btn-sm pull-right"
            >
              {{ $t("common.delete_modal.btnYes") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
    <div class="modal fade" id="modal-send-notification-event">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="closeModalSendNotification()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("eventManagement.sendNotificationTitle") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                {{ $t('eventManagement.sendNotificationContent', { '0': eventSelect && eventSelect.eventName}) }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="onConfirmSendNotification()"
              type="button"
              class="btn btn-primary btn-sm pull-right"
            >
              {{ $t("common.delete_modal.btnYes") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModalSendNotification()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Paginator from "@/components/CustomPaginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import datePicker from "vue-bootstrap-datetimepicker";
import utils from "@/lib/utils";
import configuration from "@/lib/config";
import axios from "axios";

export default {
  components: {
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "date-picker": datePicker
  },
  data() {
    return {
      noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
      searchData: {
        searchText: null,
        startDateTime: null,
        endDateTime: null
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      managementEventList: [],
      currentPage: 1,
      totalRows: 1,
      entryId: 0,
      perPage: 50,
      isLoading: false,
      isModalVisible: false,
      gridColumns: [
        {
          key: "nonumber",
          label: "user_guest.nonumber",
          class: "text-center"
        },
        {
          key: "eventName",
          label: "eventManagement.eventName",
          class: "text-center"
        },
        {
          key: "startDate",
          label: "eventManagement.startDate",
          class: "text-center"
        },
        {
          key: "endDate",
          label: "eventManagement.endDate",
          class: "text-center"
        },
        {
          key: "actions",
          label: "common.action",
          class: "text-center"
        }
      ],
      customColumns: {
        "user.is_active": {
          true: "btn-label label-success glyphicon glyphicon-ok",
          false: "btn-label label-danger glyphicon glyphicon-remove"
        }
      },
      eventIdSelected: null,
      eventData: {
        id: 0,
        eventName: null,
        startTime: null,
        startDate: null,
        endTime: null,
        endDate: null,
        content: null,
        imgUrl: null
      },
      timePickerOptions: {
        format: "HH:mm",
        useCurrent: false
      },
      datePickerOptions: {
        format: "DD-MM-YYYY",
        useCurrent: false
      },
      endDatePickerOptions: {
        format: "DD-MM-YYYY",
        useCurrent: false,
        minDate: null
      },
      isUpdate: false,
      token: null,
      media_dns: null,
      eventSelect: null
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATOR",
      "PAGINATION",
      "GET_ACCOUNT_DATA",
      "GET_EVENT_LIST_DATA"
    ])
  },
  watch: {
    GET_EVENT_LIST_DATA: function() {
      let paginate = this.GET_EVENT_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_EVENT_LIST_DATA.results;
      this.managementEventList = [];
      for (let i = 0, size = data.length; i < size; i++) {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let object = {
          id: data[i].id,
          nonumber: nonumber,
          eventName: data[i].name,
          startDate: utils.formatSqlDate(data[i].start_time, null, "DD-MM-YYYY"),
          startTime: utils.formatSqlDate(data[i].start_time, null, "HH:mm"),
          endDate: utils.formatSqlDate(data[i].end_time, null, "DD-MM-YYYY"),
          endTime: utils.formatSqlDate(data[i].end_time, null, "HH:mm"),
          content: data[i].content,
          imgUrl: data[i].img_url
        };
        this.managementEventList.push(object);
      }
    }
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_EVENT_LIST",
      "CREATE_EVENT",
      "UPDATE_EVENT",
      "DELETE_EVENT",
      "GET_TOKEN_UPLOAD",
      "SEND_NOTIFICATION_EVENT_TO_CUSTOMER"
    ]),
    spliceString: function(strText, len) {
      return utils.spliceString(strText, len);
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    formatDate(date) {
      return utils.formatSqlDate(date, null, "DD/MM/YYYY");
    },
    /**
     * Edit banner
     */
    onEditEvent: function(data) {
      this.eventData.id = data.id;
      this.eventData.eventName = data.eventName;
      this.eventData.startTime = data.startTime;
      this.eventData.startDate = data.startDate;
      this.eventData.endTime = data.endTime;
      this.eventData.endDate = data.endDate;
      this.eventData.content = data.content;
      this.eventData.imgUrl = data.imgUrl
      this.onShowModal();
    },
    /**
     * Confirm delete banner
     */
    onConfirmDeleteEvent: function() {
      this.DELETE_EVENT({ id: this.eventIdSelected })
        .then(
          function() {
            this.SUCCESS_TOAST();
            $("#modal-confirm-delete-event").modal("hide");
            this.getEventList(this.paginateData.currentPage);
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    /**
     * Edit banner
     */
    onDeleteEvent: function(id) {
      this.eventIdSelected = id;
      $("#modal-confirm-delete-event").modal("show");
    },
    callback: function() {
      this.isUpdate = false;
      this.onShowModal();
      this.eventData = {
        id: 0,
        eventName: null,
        startTime: null,
        startDate: null,
        endTime: null,
        endDate: null,
        content: null,
        imgUrl: null
      };
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getEventList(data);
    },
    /**
     * Get banner list
     */
    getEventList: function(page) {
      const data = {
        params: {
          page: page,
          searchText: this.searchData.searchText,
          startTime: utils.formatSqlUtcDate(this.searchData.startDateTime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          endTime: utils.formatSqlUtcDate(this.searchData.endDateTime, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss")
        }
      };
      this.isLoading = true;
      this.GET_EVENT_LIST(data)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onShowModal: function() {
      $("#modal-management-event-detail").modal("show");
    },
    onCloseModal: function() {
      $("#modal-management-event-detail").modal("hide");
    },
    validateData: function() {
      let validateResults = "OK";
      for (let key in this.eventData) {
        if (key === "startTime" || key === "endTime" || key === "imgUrl") {
          //
        } else if (utils.isEmptyString(this.eventData[key])) {
          validateResults = this.$t("eventManagement." + key);
        }
      }
      return validateResults;
    },
    getEventDateTime: function(dateValue, timeValue) {
      let result = null;
      if (!utils.isEmptyString(timeValue)) {
        result = utils.formatSqlUtcDate(dateValue + timeValue, "DD-MM-YYYY HH:mm", "YYYY-MM-DD HH:mm");
      } else {
        result = utils.formatSqlUtcDate(dateValue, "DD-MM-YYYY", "YYYY-MM-DD HH:mm");
      }
      return result;
    },
    onSave: function() {
      let result = this.validateData();
      let startTime = this.getEventDateTime(
        this.eventData.startDate,
        this.eventData.startTime
      );
      let endTime = this.getEventDateTime(
        this.eventData.endDate,
        this.eventData.endTime
      );
      if (result === "OK") {
        //
        if (startTime > endTime) {
          this.onShowError(this.$t("eventManagement.errorStartAndEndTime"));
        } else {
          let data = {
            id: this.eventData.id,
            name: this.eventData.eventName,
            startTime: startTime,
            endTime: endTime,
            content: this.eventData.content,
            imgUrl: this.eventData.imgUrl
          };
          if (this.eventData.id === 0) {
            this.CREATE_EVENT(data)
              .then(
                function() {
                  this.onCloseModal();
                  this.getEventList(this.paginateData.currentPage);
                  this.SUCCESS_TOAST();
                }.bind(this)
              )
              .catch(
                function() {
                  this.ERROR_TOAST();
                }.bind(this)
              );
          } else {
            this.UPDATE_EVENT(data)
              .then(
                function() {
                  this.onCloseModal();
                  this.getEventList(this.paginateData.currentPage);
                  this.SUCCESS_TOAST();
                }.bind(this)
              )
              .catch(
                function() {
                  this.ERROR_TOAST();
                }.bind(this)
              );
          }
        }
      } else {
        this.onShowError(result);
      }
    },
    onSearchEvent: function() {
      this.getEventList(1);
    },
    /**
     * Select issuance img
     */
    onSelectImg: async function (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      await this.getImgFile(files[0])
      this.imgUrl = URL.createObjectURL(files[0])
      await this.uploadImgfile()
    },
    getImgFile: function(file) {
      let vm = this;
      vm.imgFile = file;
    },
    uploadImgfile: async function () {
      let formData = new FormData()
      formData.append('file', this.imgFile)
      formData.append('directory', 'apartment/event/img/')
      formData.append('forceOverride', true)
      await axios({
        method: 'POST',
        timeout: 6000,
        url: this.media_dns + '/api/v1/upload/',
        data: formData,
        headers: { Authorization: `JWT ${this.token}` }
      }).then(
        async function (res) {
          let data = res.data
          this.eventData.imgUrl = data.domain + data.url
        }.bind(this)
      ).catch(
        async function () {
          this.eventData.imgUrl = null
        }.bind(this)
      )
    },
    /**
     * Remove issuance img
     */
    onClickRemoveImg: function () {
      let inputForm = $('#upload-news-img')
      inputForm.val('')
      this.eventData.imgUrl = null
      // this. = null
    },
    // send notification
    closeModalSendNotification() {
      $("#modal-send-notification-event").modal("hide");
    },
    showModalSendNotification() {
      $("#modal-send-notification-event").modal("show");
    },
    showModalConfirmSendNotification: function(data) {
      this.eventSelect = data
      this.showModalSendNotification()
    },
    onConfirmSendNotification: function() {
      let data = {
        eventId: this.eventSelect && this.eventSelect.id
      }
      this.isLoading = true
      this.SEND_NOTIFICATION_EVENT_TO_CUSTOMER(data)
        .then(
          function() {
            this.closeModalSendNotification();
            this.SUCCESS_TOAST();
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message
            this.onShowError(mess);
            this.isLoading = false
          }.bind(this)
        );
    }
  },
  mounted() {
    $(function () {
      $('#event-img-id').on('click', function () {
        $('#upload-event-img').val('')
        $('#upload-event-img').click()
      })
    });
    this.getEventList(1);
    this.GET_TOKEN_UPLOAD()
      .then(
        function(res) {
          this.token = res.token;
          this.media_dns = res.domain;
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
  }
};
</script>
<style scoped>
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

input[type="file"] {
  display: none;
}

.remove-banner-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-banner-img:hover{
  text-decoration: underline;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 25px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
}
.news-img-class{
  width: 100%;
  cursor: pointer;
  margin: auto;
  max-width: 250px;
  max-height: 300px;
}
.remove-news-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-news-img:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/Event/EventList.vue